import * as types from './mutation-types';
import growplansService from '../../services/growplans'
import { createServiceCall } from '../actionsUtil'

export const getGrowplan = createServiceCall({
  mainAction: types.GET_GROWPLAN_REQUEST,
  serviceFunction: growplansService.getGrowplan,
  successAction: types.GET_GROWPLAN_SUCCESS,
  successDataProperty: "getGrowplan",
  failureAction: types.GET_GROWPLAN_FAILURE
});

export const getPlantContainerTypes = createServiceCall({
  mainAction: types.GET_PLANT_CONTAINER_TYPES_REQUEST,
  serviceFunction: growplansService.getPlantContainerTypes,
  successAction: types.GET_PLANT_CONTAINER_TYPES_SUCCESS,
  successDataProperty: "plantcontainerTypes",
  failureAction: types.GET_PLANT_CONTAINER_TYPES_FAILURE
});

export const deleteGrowTask = createServiceCall({
  mainAction: types.DELETE_GROW_TASK_REQUEST,
  serviceFunction: growplansService.deleteGrowTask,
  successAction: types.DELETE_GROW_TASK_SUCCESS,
  successDataProperty: "deleteGrowTask",
  failureAction: types.DELETE_GROW_TASK_FAILURE
});